import axios from 'axios';
import { API } from '@/constants/api';
import { GetStoresProps, StoreApi } from './types';

export const getStores = async ({
  companyId,
  isActive = true,
}: GetStoresProps): Promise<StoreApi[]> =>
  (
    await axios.get<{ stores: StoreApi[] }>(`${API.endpoint}/companies/${companyId}/stores`, {
      params: {
        is_active: isActive,
      },
    })
  )?.data?.stores || [];
